import { createAction } from "redux-actions";

// fetch all AgentAnalytic
export const FETCH_AGENT_ANALYTIC = "FETCH_AGENT_ANALYTIC";
export const fetchAgentAnalytic = createAction(FETCH_AGENT_ANALYTIC);

export const FETCH_AGENT_ANALYTIC_REQUESTED = "FETCH_AGENT_ANALYTIC_REQUESTED";
export const fetchAgentAnalyticRequested = createAction(FETCH_AGENT_ANALYTIC_REQUESTED);

export const FETCH_AGENT_ANALYTIC_FAILURE = "FETCH_AGENT_ANALYTIC_FAILURE";
export const fetchAgentAnalyticFailure = createAction(FETCH_AGENT_ANALYTIC_FAILURE);

export const FETCH_AGENT_ANALYTIC_SUCCESS = "FETCH_AGENT_ANALYTIC_SUCCESS";
export const fetchAgentAnalyticSuccess = createAction(FETCH_AGENT_ANALYTIC_SUCCESS);
